<template>
  <div class="component">
    <div>
      <help portal="mycfm" class="pull-right padding-80" />
      <input
        type="submit"
        class="btn btn-sm btn-primary pull-right btn-resume-draft"
        value="Save as Draft & Exit"
        @click.prevent="displayRecaptcha(true);"
      />
    </div>
    <p class="h4 heading">User Information</p>
    <p>
      Thank you for providing your company details. As the first applicant from your company, you will automatically be
      appointed as the primary contact for your company until a separate contact is specified. Please fill out the
      required information below to register as a new user of myCFMportal.
    </p>
    <form>
      <div class="name-form-group">
        <label class="control-label required" for="firstName">Name</label>
        <div class="form-inline">
          <div class="form-group">
            <input
              id="firstName"
              v-model.trim="userDetails.firstName"
              v-focus
              type="text"
              class="form-control"
              placeholder="First Name"
              @blur="$v.userDetails.firstName.$touch();"
            />
            <div v-if="!$v.userDetails.firstName.required && $v.userDetails.firstName.$error" class="text-danger">
              First Name cannot be empty
            </div>
            <div v-if="!$v.userDetails.firstName.maxLength && $v.userDetails.firstName.$error" class="text-danger">
              Allowed upto 100 characters only
            </div>
          </div>
          <div class="form-group">
            <input
              v-model.trim="userDetails.middleName"
              type="text"
              class="form-control middle-name"
              placeholder="Middle Name"
              @blur="$v.userDetails.middleName.$touch();"
            />
            <div v-if="!$v.userDetails.middleName.maxLength && $v.userDetails.middleName.$error" class="text-danger">
              Allowed upto 100 characters only
            </div>
          </div>
          <div class="form-group">
            <input
              v-model.trim="userDetails.lastName"
              type="text"
              placeholder="Last Name"
              class="form-control"
              @blur="$v.userDetails.lastName.$touch();"
            />
            <div v-if="!$v.userDetails.lastName.required && $v.userDetails.lastName.$error" class="text-danger">
              Last Name cannot be empty
            </div>
            <div v-if="!$v.userDetails.lastName.maxLength && $v.userDetails.lastName.$error" class="text-danger">
              Allowed upto 100 characters only
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="email" class="control-label required">E-mail Address</label>
        <input id="email" v-model="userDetails.email" type="email" disabled class="form-control" />
        <div v-if="$v.userDetails.email.$error" class="text-danger">Plase enter valid email address</div>
      </div>
      <div class="form-group">
        <label for="contactNumber" class="control-label required">User Phone number</label>
        <input
          id="contactNumber"
          v-model.trim="userDetails.contactNumber"
          type="text"
          class="form-control"
          @blur="$v.userDetails.contactNumber.$touch();"
        />
        <div v-if="!$v.userDetails.contactNumber.required && $v.userDetails.contactNumber.$error" class="text-danger">
          Plase enter valid phone number
        </div>
        <div v-if="!$v.userDetails.contactNumber.maxLength && $v.userDetails.contactNumber.$error" class="text-danger">
          Allowed upto 15 characters only
        </div>
      </div>
      <div class="form-group">
        <label for="country" class="control-label required">Country of Citizenship</label>
        <select
          id="country"
          v-model="userDetails.countryId"
          class="form-control"
          @blur="$v.userDetails.countryId.$touch();"
          @change="displayGreenCard"
        >
          <option value="">Please select country</option>
          <option v-for="country in countries" :key="country.cntryId" :value="country.cntryId">
            {{ country.cntryNm }}
          </option>
        </select>
        <div v-if="!$v.userDetails.countryId.required && $v.userDetails.countryId.$error" class="text-danger">
          Select your country
        </div>
      </div>
      <div v-if="showGreenCardDetails" class="row form-group">
        <div class="col-md-3">
          <label class="control-label required" for="greenCard">US Green Card Holder?</label>
          <div class="form-inline">
            <div class="form-group">
              <select id="country" v-model="userDetails.greenCard" class="form-control">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              <div v-if="!$v.userDetails.greenCard.required && $v.userDetails.greenCard.$error" class="text-danger">
              Please select US Green Card Holder
              </div>
            </div>
          </div>
        </div>
        <div v-if="userDetails.greenCard == 'Yes'" class="col-md-3">
          <label class="control-label required" for="greenCardExp">Expiration Date</label>
          <div class="form-inline">
            <div class="form-group">
              <datepicker
                id="exp"
                v-model.trim="userDetails.greenCardExp"
                v-focus
                placeholder="(MM/DD/YYYY)"
                :bootstrap-styling="true"
                format="MM/dd/yyyy"
                @blur="$v.userDetails.greenCardExp.$touch();"
              ></datepicker>
              <div
                v-if="!$v.userDetails.greenCardExp.required && $v.userDetails.greenCardExp.$error"
                class="text-danger"
              >
                Expiration date cannot be empty
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="" class="control-label required">Do you need the ability to Purchase Parts?</label>
        <div class="radio-btns">
            <div class="radio-btn">
              <input
                id="materialBuyerAccessYes"
                v-model="userDetails.materialBuyerAccess"
                type="radio"
                value="Yes"
              />
              <label for="materialBuyerAccessYes">Yes</label>
            </div>
            <div class="radio-btn">
              <input id="materialBuyerAccessNo" v-model="userDetails.materialBuyerAccess" type="radio" value="No"/>
              <label for="materialBuyerAccessNo">No</label>
            </div>
        </div>
        <div v-if="!$v.userDetails.materialBuyerAccess.required && $v.userDetails.materialBuyerAccess.$error" class="text-danger">
          Please select do you need the ability to Purchase Parts
        </div>
      </div>
      <div class="action-btns">
        <input
          type="submit"
          class="btn btn-sm btn-primary"
          value="Request Access"
          @click.prevent="displayRecaptcha(false);"
        />
        <input type="button" value="Back" class="btn btn-sm btn-default" @click="goBack" />
      </div>
    </form>
    <BotControlAOB
      :display-data="showRecaptcha"
      @closeModal="showRecaptcha = false;"
      @recaptchaResponseData="submitRegisterCompany"
    />
  </div>
</template>
<script>
import { email, required, maxLength, requiredIf } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
import moment from "moment";
import BotControlAOB from "@/mycfm/components/new-company/BotControlAOB";
import help from "@/mycfm/components/HelpInfo";

export default {
  components: {
    Datepicker,
    BotControlAOB,
    help
  },
  props: {
    portal: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showSpinner: false,
      showGreenCardDetails: false,
      showRecaptcha: false,
      isDraft: false
    };
  },
  computed: {
    ...mapState("companyUser", ["userDetails"]),
    ...mapState("country", ["countries"]),
    ...mapState("user", ["user"])
  },
  validations: {
    userDetails: {
      firstName: {
        required,
        maxLength: maxLength(100)
      },
      middleName: {
        maxLength: maxLength(100)
      },
      lastName: {
        required,
        maxLength: maxLength(100)
      },
      email: {
        email,
        required
      },
      countryId: {
        required
      },
      contactNumber: {
        required,
        maxLength: maxLength(15)
      },
      greenCard: {
        required: requiredIf(function() {
          return this.userDetails.countryId != 232;
        })
      },
      greenCardExp: {
        required: requiredIf(function() {
          return this.userDetails.greenCard === "Yes";
        })
      },
      materialBuyerAccess: {
        required
      }
    }
  },
  created() {
    this.$store.dispatch("country/getCountries");
    if (this.$store.state.companyUser.userDetails.countryId) {
      this.userDetails.countryId = this.$store.state.companyUser.userDetails.countryId;
      if (this.userDetails.countryId != 232) {
        this.showGreenCardDetails = true;
      } else {
        this.showGreenCardDetails = false;
      }
      if (this.$store.state.companyUser.userDetails.greenCardExp) {
        this.userDetails.greenCardExp = moment(this.$store.state.companyUser.userDetails.greenCardExp).format(
          "YYYY-MM-DD"
        );
      }
    }
  },
  updated() {
    if (window.grecaptcha) {
      window.grecaptcha.reset();
    }
  },
  methods: {
    displayRecaptcha(saveDraft) {
      this.isDraft = saveDraft;

      if (!saveDraft) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
      }
      this.showRecaptcha = true;
      if (window.grecaptcha) {
        window.grecaptcha.reset();
      }
    },
    displayGreenCard: function(event) {
      this.showGreenCardDetails = event.target.value != 232 ? true : false;
      this.$store.state.companyUser.userDetails.countryId = event.target.value;
    },
    submitRegisterCompany(data) {
      if (this.userDetails.greenCard == "Yes") {
        if (this.$store.state.companyUser.userDetails.greenCardExp) {
          this.$store.state.companyUser.userDetails.greenCardExp = moment(this.userDetails.greenCardExp).format(
            "MM/DD/YYYY"
          );
        }
      } else {
        this.userDetails.greenCardExp = "";
      }
      this.$emit("complete", this.isDraft, data);
    },
    goBack() {
      this.$store.dispatch("companyUser/clearUserDetails");
      this.$emit("back");
    }
  }
};
</script>
<style lang="less" scoped>
form {
  margin-top: 25px;
  padding-bottom: 260px;
}

.privacy-form-group {
  margin-bottom: 25px;
}

.name-form-group {
  margin-bottom: 15px;

  .form-group {
    vertical-align: top;

    .form-control {
      width: 200px;
      margin-right: 10px;
    }
  }
}

.fullname-label {
  display: block;
}

.form-group {
  input:not([type=radio]),
  textarea,
  select {
    width: 280px;
  }
}

.checkbox-inline input {
  width: auto;
}

@media all and (max-width: 770px) {
  .name-form-group {
    .form-group {
      .form-control {
        width: 280px;
      }
    }
  }
}
</style>
